import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'animate.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router } from 'react-router-dom';
import NetworkStatus from './components/NetworkStatus';
// import 'react-calendar-timeline/lib/Timeline.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Toaster
      containerStyle={{
        zIndex: 99999999999,
      }}
      toastOptions={{
        // Ensure it's above modals (SimpleModal uses z-[999999]) + match dark UI theme
        style: {
          zIndex: 99999999999,
          background: '#1E1F22',
          color: '#FFFFFF',
          border: '1px solid rgba(255,255,255,0.08)',
          boxShadow: '0 10px 30px rgba(0,0,0,0.45)',
        },
        success: {
          iconTheme: { primary: '#22c55e', secondary: '#1E1F22' },
        },
        error: {
          iconTheme: { primary: '#ef4444', secondary: '#1E1F22' },
        },
      }}
    />
    <Provider store={store}>
      <App />
      <NetworkStatus />
    </Provider>
  </Router>
);
